import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePickerConfigurationValue } from '@app/sharedModule/components/date-picker-configuration/date-picker-configuration.types';
import { DatePickerProfileForm } from '../../date-picker-tab.utils';

@Component({
  selector: 'multi-shipment-date-picker-profile',
  templateUrl: './date-picker-profile.component.html',
  styleUrls: ['./date-picker-profile.component.scss'],
  standalone: false,
})
export class DatePickerProfileComponent {
  @Input({ required: true }) formGroup!: FormGroup<DatePickerProfileForm>;
  @Input() sectionId = '';

  @Output() remove = new EventEmitter<void>();

  onDatePickerConfigChange(value: DatePickerConfigurationValue): void {
    this.formGroup.controls.configuration.setValue(value);
    this.formGroup.controls.configuration.markAsDirty();
  }
}
